module.exports = __webpack_public_path__ + "static/media/chevron-right-navy-blue.f3c983b2.svg";